<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <mainLoader v-if="mainLoading" />
        <div v-if="!mainLoading" class="row">
          <div class="col">
            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">نوع العملية: <span class="req">*</span></label>
                <select v-model="OperationType" class="form-control">
                  <option :value="null">اختر نوع العملية</option>
                  <option v-for="(val, key) in operationTypeChoices" :value="key" :key="key">{{ val }}</option>
                </select>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">سبب العملية: <span class="req">*</span></label>
                <select v-model="OperationReason" class="form-control">
                  <option :value="null">اختر سبب العملية</option>
                  <option v-for="(val, key) in operationReasonChoices[OperationType]" :value="key" :key="key">{{ val }}</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">رابط الإعلان في المنصة العقارية: <span class="req">*</span></label>
                <input type="text" class="form-control" v-model="AdLinkInPlatform" />
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">رقم ترخيص الإعلان: <span class="req">*</span></label>
                <input type="text" class="form-control" v-model="AdLicenseNumber" />
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">رقم رخصة الوساطة والتسويق / رخصة فال للوساطة والتسويق للمنصات العقارية الإلكترونية</label>
                <input type="text" class="form-control" v-model="BrokerageAndMarketingLicenseNumber" />
                <div class="form-text">رقم رخصة الوساطة والتسويق للمعلن إذا كان المعلن وسيطاً عقارياً ، أما إذا كان المعلن هو مالك العقار أو ممثله فلا يتم إرسال قيمة في هذا الحقل</div>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">رقم وثيقة الملكية / ملكية المنفعة: <span class="req">*</span></label>
                <input type="text" class="form-control" v-model="TitleDeedNumber" />
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">تاريخ إنشاء ترخيص الإعلان: <span class="req">*</span></label>
                <input type="date" class="form-control" v-model="CreationDate" />
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">تاريخ إنتهاء ترخيص الإعلان: <span class="req">*</span></label>
                <input type="date" class="form-control" v-model="EndDate" />
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">رقم هوية المُعلن: <span class="req">*</span></label>
                <input type="text" class="form-control" v-model="AdvertiserID" />
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">اسم المُعلن: <span class="req">*</span></label>
                <input type="text" class="form-control" v-model="AdvertiserName" />
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">رقم التواصل للمُعلن: <span class="req">*</span></label>
                <input type="text" class="form-control" v-model="AdvertiserMobile" />
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">قنوات الإعلان: <span class="req">*</span></label>
                <select v-model="Channels" class="form-control" multiple>
                  <option v-for="(val, key) in channelsChoices" :value="val" :key="key">{{ val }}</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">العنوان الوطني: <span class="req">*</span></label>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">المنطقة: <span class="req">*</span></label>
                <select v-model="NationalAddress.Region" class="form-control" @change="getCitiesList">
                  <option :value="null">اختر المنطقة</option>
                  <option v-for="val in regionsList" :value="val.regaId" :key="val.id">{{ val.name }}</option>
                </select>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">المدينة: <span class="req">*</span></label>
                <select v-model="NationalAddress.City" class="form-control" @change="getNeighborhoodsList">
                  <option :value="null">اختر المدينة</option>
                  <option v-for="val in citiesList" :value="val.regaId" :key="val.id">{{ val.name }}</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">الحي: <span class="req">*</span></label>
                <select v-model="NationalAddress.District" class="form-control">
                  <option :value="null">اختر الحي</option>
                  <option v-for="val in neighborhoodsList" :value="val.regaId" :key="val.id">{{ val.name }}</option>
                </select>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">الرمز البريدي:</label>
                <input type="text" v-model="NationalAddress.PostalCode" class="form-control">
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">اسم الشارع:</label>
                <input type="text" v-model="NationalAddress.StreetName" class="form-control">
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">رقم المبنى:</label>
                <input type="text" v-model="NationalAddress.BuildingNo" class="form-control">
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">رقم إضافي:</label>
                <input type="text" v-model="NationalAddress.AdditionalNo" class="form-control">
              </div>
            </div>
            
            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">الاحداث العرضي بالخريطة (Latitude):</label>
                <input type="text" v-model="NationalAddress.AdMAPLatitude" class="form-control">
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">الاحداث الطولي بالخريطة (Longitude):</label>
                <input type="text" v-model="NationalAddress.AdMAPLongitude" class="form-control">
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">واجهة العقار</label>
                <select v-model="PropertyFace" class="form-control">
                  <option :value="null">اختر واجهة العقار</option>
                  <option v-for="(val, key) in propertyFaceChoices" :value="val" :key="key">{{ val }}</option>
                </select>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">نوع العقار: <span class="req">*</span></label>
                <select v-model="PropertyType" class="form-control">
                  <option :value="null">اختر نوع العقار</option>
                  <option v-for="(val, key) in propertyTypeChoices" :value="val" :key="key">{{ val }}</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">مساحة العقار: <span class="req">*</span></label>
                <input type="text" v-model="PropertyArea" class="form-control" />
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">استخدام العقار:</label>
                <select v-model="PropertyUsage" class="form-control" multiple>
                  <option v-for="(val, key) in propertyUsageChoices" :value="val" :key="key">{{ val }}</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">عرض الشارع:</label>
                <input type="text" v-model="StreetWidth" class="form-control" />
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">عمر العقار:</label>
                <select v-model="PropertyAge" class="form-control">
                  <option :value="null">اختر عمر العقار</option>
                  <option v-for="(val, key) in propertyAgeChoices" :value="val" :key="key">{{ val }}</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">سعر المتر للارض / سعر الوحدة: <span class="req">*</span></label>
                <input type="text" v-model="Price" class="form-control" />
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">عدد الغرف:</label>
                <input type="text" v-model="RoomsNumber" class="form-control" />
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">خدمات العقار: <span class="req">*</span></label>
                <select v-model="PropertyUtilities" class="form-control" multiple>
                  <option v-for="(val, key) in propertyUtilitiesChoices" :value="val" :key="key">{{ val }}</option>
                </select>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">غرض الإعلان: <span class="req">*</span></label>
                <select v-model="AdType" class="form-control">
                  <option :value="null">اختر غرض الإعلان</option>
                  <option v-for="(val, key) in adTypeChoices" :value="val" :key="key">{{ val }}</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">يوجد قيود على العقار؟: <span class="req">*</span></label>
                <select v-model="IsConstrained" class="form-control">
                  <option :value="true">نعم</option>
                  <option :value="false">لا</option>
                </select>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">الإلتزامات على العقار:</label>
                <textarea v-model="ObligationsOntheProperty" class="form-control" rows="5"></textarea>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">الضمانات ومدتها:</label>
                <textarea v-model="GuaranteesAndTheirDuration" class="form-control" rows="5"></textarea>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">رقم المخطط:</label>
                <input type="text" v-model="PlanNumber" class="form-control" />
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">رقم القطعة:</label>
                <input type="text" v-model="landNumber" class="form-control" />
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">مطابقة كود البناء السعودي؟</label>
                <select v-model="ComplianceWithTheSaudiBuildingCode" class="form-control">
                  <option :value="null">اختر</option>
                  <option value="نعم">نعم</option>
                  <option value="لا">لا</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">رابط ترخيص الإعلان العقاري: <span class="req">*</span></label>
                <input type="text" v-model="adLicenseURL" class="form-control" />
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">نوع وثيقة الملكية / المنفعة:</label>
                <select v-model="TitleDeedType" class="form-control">
                  <option :value="null">اختر النوع</option>
                  <option v-for="(val, key) in titleDeedTypeChoices" :value="val" :key="key">{{ val }}</option>
                </select>
              </div>
            </div>

            <div class="row mb-3"><div class="col"><hr /></div></div>
              <div class="row">
                <div class="col">في حال كان الصك لم يكن صادر من السجل العقاري ، بمعنى انه إذا كانت وثيقة الملكية صك إلكتروني صادر من وزارة العدل أو كانت أحد وثائق الملكية أو ملكية المنفعة غير الإلكترونية </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">نوع الحد الشمالي:</label>
                  <input type="text" v-model="NorthLimitName" class="form-control" />
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">وصف الحد الشمالي:</label>
                  <input type="text" v-model="NorthLimitDescription" class="form-control" />
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">طول الحد الشمالي:</label>
                  <input type="text" v-model="NorthLimitLengthChar" class="form-control" />
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">نوع الحد الشرقي:</label>
                  <input type="text" v-model="EastLimitName" class="form-control" />
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">وصف الحد الشرقي:</label>
                  <input type="text" v-model="EastLimitDescription" class="form-control" />
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">طول الحد الشرقي:</label>
                  <input type="text" v-model="EastLimitLengthChar" class="form-control" />
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">نوع الحد الغربي:</label>
                  <input type="text" v-model="WestLimitName" class="form-control" />
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">وصف الحد الغربي:</label>
                  <input type="text" v-model="WestLimitDescription" class="form-control" />
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">طول الحد الغربي:</label>
                  <input type="text" v-model="WestLimitLengthChar" class="form-control" />
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">نوع الحد الجنوبي:</label>
                  <input type="text" v-model="SouthLimitName" class="form-control" />
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">وصف الحد الجنوبي:</label>
                  <input type="text" v-model="SouthLimitDescription" class="form-control" />
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">طول الحد الجنوبي:</label>
                  <input type="text" v-model="SouthLimitLengthChar" class="form-control" />
                </div>
              </div>
            <div class="row mb-3"><div class="col"><hr /></div></div>
              <div class="row"><div class="col">الحدود: في حال كان الصك صادر من السجل العقاري</div></div>
              <div class="row">
                <div class="col-12">
                  <label for="" class="form-label">الحد الاول:</label>
                  <div class="row">
                    <div class="col-6 col-sm-4">
                      <input type="text" v-model="Borders[0]['Direction']" class="form-control" placeholder="الإتجاه" />
                    </div>
                    <div class="col-6 col-sm-4">
                      <input type="text" v-model="Borders[0]['Type']" class="form-control" placeholder="النوع" />
                    </div>
                    <div class="col-6 col-sm-4">
                      <input type="text" v-model="Borders[0]['length']" class="form-control" placeholder="الطول" />
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <label for="" class="form-label">الحد الثاني:</label>
                  <div class="row">
                    <div class="col-6 col-sm-4">
                      <input type="text" v-model="Borders[1]['Direction']" class="form-control" placeholder="الإتجاه" />
                    </div>
                    <div class="col-6 col-sm-4">
                      <input type="text" v-model="Borders[1]['Type']" class="form-control" placeholder="النوع" />
                    </div>
                    <div class="col-6 col-sm-4">
                      <input type="text" v-model="Borders[1]['length']" class="form-control" placeholder="الطول" />
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <label for="" class="form-label">الحد الثالث:</label>
                  <div class="row">
                    <div class="col-6 col-sm-4">
                      <input type="text" v-model="Borders[2]['Direction']" class="form-control" placeholder="الإتجاه" />
                    </div>
                    <div class="col-6 col-sm-4">
                      <input type="text" v-model="Borders[2]['Type']" class="form-control" placeholder="النوع" />
                    </div>
                    <div class="col-6 col-sm-4">
                      <input type="text" v-model="Borders[2]['length']" class="form-control" placeholder="الطول" />
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <label for="" class="form-label">الحد الرابع:</label>
                  <div class="row">
                    <div class="col-6 col-sm-4">
                      <input type="text" v-model="Borders[3]['Direction']" class="form-control" placeholder="الإتجاه" />
                    </div>
                    <div class="col-6 col-sm-4">
                      <input type="text" v-model="Borders[3]['Type']" class="form-control" placeholder="النوع" />
                    </div>
                    <div class="col-6 col-sm-4">
                      <input type="text" v-model="Borders[3]['length']" class="form-control" placeholder="الطول" />
                    </div>
                  </div>
                </div>
              </div>
            <div class="row mb-3"><div class="col"><hr /></div></div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">مصدر ترخيص الإعلان: <span class="req">*</span></label>
                <select v-model="AdSource" class="form-control">
                  <option :value="null">اختر المصدر</option>
                  <option v-for="(val, key) in adSourceChoices" :value="val" :key="key">{{ val }}</option>
                </select>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">اجمالي سعر بيع الارض:</label>
                <input type="text" v-model="LandTotalPrice" class="form-control" />
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">اجمالي الإيجار السنوي للارض:</label>
                <input type="text" v-model="TotalAnnualRentForTheLand" class="form-control" />
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">الملاحظات:</label>
                <textarea v-model="Notes" class="form-control" rows="5"></textarea>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">وصف موقع العقار حسب الصك:</label>
                <textarea v-model="LocationDescriptionAccordingToDeed" class="form-control" rows="5"></textarea>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">رسوم نقل الملكية:</label>
                <input type="text" v-model="ownershipTransferFeeType" class="form-control" />
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">مسؤول الإعلان:</label>
                <input type="text" v-model="responsibleEmployeeName" class="form-control" />
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">رقم مسؤول الإعلان:</label>
                <input type="text" v-model="responsibleEmployeePhoneNumber" class="form-control" />
              </div>
            </div>

          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div v-if="!mainLoading" class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'RegaUpdateForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data(){
    return {
      mainLoading: true,
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      // lookups 
      operationTypeChoices: {}, 
      operationReasonChoices: {}, 
      channelsChoices: {}, 
      propertyFaceChoices: {}, 
      propertyTypeChoices: {}, 
      propertyUsageChoices: {},
      propertyAgeChoices: {}, 
      propertyUtilitiesChoices: {}, 
      adTypeChoices: {},
      titleDeedTypeChoices: {}, 
      adSourceChoices: {},
      regionsList: [],
      citiesList: [],
      neighborhoodsList: [],
      // data 
      OperationType: null,
      OperationReason: null,
      AdLinkInPlatform: null,
      AdLicenseNumber: null,
      TitleDeedNumber: null,
      CreationDate: null,
      EndDate: null,
      AdvertiserID: null,
      AdvertiserName: null,
      AdvertiserMobile: null,
      Channels: [],
      NationalAddress: {},
      PropertyType: null,
      PropertyArea: null,
      Price: null,
      PropertyUtilities: [],
      AdType: null,
      IsConstrained: false,
      adLicenseURL: null,
      AdSource: null,
      // optional
      BrokerageAndMarketingLicenseNumber: null,
      PropertyFace: null, 
      PropertyUsage: [], 
      StreetWidth: null, 
      PropertyAge: null, 
      RoomsNumber: null, 
      ObligationsOntheProperty: null, 
      GuaranteesAndTheirDuration: null, 
      PlanNumber: null, 
      landNumber: null, 
      ComplianceWithTheSaudiBuildingCode: null, 
      TitleDeedType: null, 
      NorthLimitName: null, 
      NorthLimitDescription: null, 
      NorthLimitLengthChar: null, 
      EastLimitName: null, 
      EastLimitDescription: null, 
      EastLimitLengthChar: null, 
      WestLimitName: null, 
      WestLimitDescription: null, 
      WestLimitLengthChar: null, 
      SouthLimitName: null, 
      SouthLimitDescription: null, 
      SouthLimitLengthChar: null, 
      Borders: [
        {Direction: null, Type: null, length: null},
        {Direction: null, Type: null, length: null},
        {Direction: null, Type: null, length: null},
        {Direction: null, Type: null, length: null},
      ], 
      LandTotalPrice: null, 
      TotalAnnualRentForTheLand: null, 
      Notes: null, 
      LocationDescriptionAccordingToDeed: null, 
      ownershipTransferFeeType: null, 
      responsibleEmployeeName: null, 
      responsibleEmployeePhoneNumber: null, 
    }
  },
  methods: {
    getInitData(){
      this.$http.get(`/api/admin/properties/regaInit/${this.id}`).then(({data}) => {
        const dataRow = data.row;
        this.operationTypeChoices = data.operationTypeChoices;
        this.operationReasonChoices = data.operationReasonChoices;
        this.channelsChoices = data.channelsChoices;
        this.propertyFaceChoices = data.propertyFaceChoices;
        this.propertyTypeChoices = data.propertyTypeChoices;
        this.propertyUsageChoices = data.propertyUsageChoices;
        this.propertyAgeChoices = data.propertyAgeChoices;
        this.propertyUtilitiesChoices = data.propertyUtilitiesChoices;
        this.adTypeChoices = data.adTypeChoices;
        this.titleDeedTypeChoices = data.titleDeedTypeChoices;
        this.adSourceChoices = data.adSourceChoices;
        this.regionsList = data.regionsList;

        // data 
        if(dataRow.AdValidator && dataRow.AdValidator.advertisement){
          this.AdLicenseNumber = dataRow.AdValidator.advertisement.adLicenseNumber ?? null;
          this.AdType = dataRow.AdValidator.advertisement.advertisementType ?? null;
          this.TitleDeedNumber = dataRow.AdValidator.advertisement.deedNumber ?? null;
          this.CreationDate = (dataRow.AdValidator.advertisement.creationDate)? this.formatDate(dataRow.AdValidator.advertisement.creationDate) : null;
          this.EndDate = (dataRow.AdValidator.advertisement.endDate)? this.formatDate(dataRow.AdValidator.advertisement.endDate) : null;
          this.AdvertiserID = dataRow.AdValidator.advertisement.advertiserId ?? null;
          this.AdvertiserName = dataRow.AdValidator.advertisement.advertiserName ?? null;
          this.AdvertiserMobile = dataRow.AdValidator.advertisement.phoneNumber ?? null;
          this.Channels = dataRow.AdValidator.advertisement.channels ?? [];
          if(dataRow.AdValidator.advertisement.location){
            this.NationalAddress = {
              Region: dataRow.AdValidator.advertisement.location.regionCode ?? null,
              City: dataRow.AdValidator.advertisement.location.cityCode ?? null,
              District: dataRow.AdValidator.advertisement.location.districtCode ?? null,
              PostalCode: dataRow.AdValidator.advertisement.location.postalCode ?? null,
              AdMAPLatitude: dataRow.AdValidator.advertisement.location.latitude ?? null,
              AdMAPLongitude: dataRow.AdValidator.advertisement.location.longitude ?? null,
              StreetName: dataRow.AdValidator.advertisement.location.street ?? null,
              BuildingNo: dataRow.AdValidator.advertisement.location.buildingNumber ?? null,
              AdditionalNo: dataRow.AdValidator.advertisement.location.additionalNumber ?? null,
            };
          }
          this.PropertyType = dataRow.AdValidator.advertisement.propertyType ?? null;
          this.PropertyArea = dataRow.AdValidator.advertisement.propertyArea ?? null;
          this.PropertyFace = dataRow.AdValidator.advertisement.propertyFace ?? null;
          this.PropertyUsage = dataRow.AdValidator.advertisement.propertyUsages ?? [];
          this.PropertyAge = dataRow.AdValidator.advertisement.propertyAge ?? null;
          this.PropertyUtilities = dataRow.AdValidator.advertisement.propertyUtilities ?? [];
          this.Price = dataRow.AdValidator.advertisement.propertyPrice ?? null;
          this.adLicenseURL = dataRow.AdValidator.advertisement.adLicenseUrl ?? null;
          this.AdSource = dataRow.AdValidator.advertisement.adSource ?? null;
          this.BrokerageAndMarketingLicenseNumber = dataRow.AdValidator.advertisement.brokerageAndMarketingLicenseNumber ?? null;
          this.StreetWidth = dataRow.AdValidator.advertisement.streetWidth ?? null;
          this.RoomsNumber = dataRow.AdValidator.advertisement.numberOfRooms ?? null;
          this.ObligationsOntheProperty = dataRow.AdValidator.advertisement.obligationsOnTheProperty ?? null;
          this.GuaranteesAndTheirDuration = dataRow.AdValidator.advertisement.guaranteesAndTheirDuration ?? null;
          this.PlanNumber = dataRow.AdValidator.advertisement.planNumber ?? null;
          this.landNumber = dataRow.AdValidator.advertisement.landNumber ?? null;
          if(dataRow.AdValidator.advertisement.borders){
            this.NorthLimitName = dataRow.AdValidator.advertisement.borders.northLimitName ?? null;
            this.NorthLimitDescription = dataRow.AdValidator.advertisement.borders.northLimitDescription ?? null;
            this.NorthLimitLengthChar = dataRow.AdValidator.advertisement.borders.northLimitLengthChar ?? null;
            this.EastLimitName = dataRow.AdValidator.advertisement.borders.eastLimitName ?? null;
            this.EastLimitDescription = dataRow.AdValidator.advertisement.borders.eastLimitDescription ?? null;
            this.EastLimitLengthChar = dataRow.AdValidator.advertisement.borders.eastLimitLengthChar ?? null;
            this.WestLimitName = dataRow.AdValidator.advertisement.borders.westLimitName ?? null;
            this.WestLimitDescription = dataRow.AdValidator.advertisement.borders.westLimitDescription ?? null;
            this.WestLimitLengthChar = dataRow.AdValidator.advertisement.borders.westLimitLengthChar ?? null;
            this.SouthLimitName = dataRow.AdValidator.advertisement.borders.southLimitName ?? null;
            this.SouthLimitDescription = dataRow.AdValidator.advertisement.borders.southLimitDescription ?? null;
            this.SouthLimitLengthChar = dataRow.AdValidator.advertisement.borders.southLimitLengthChar ?? null;
          }
          if(dataRow.AdValidator.advertisement.rerBorders && dataRow.AdValidator.advertisement.rerBorders.length){
            if(dataRow.AdValidator.advertisement.rerBorders[0])
              this.Borders[0] = {
                Direction: dataRow.AdValidator.advertisement.rerBorders[0].direction ?? null, 
                Type: dataRow.AdValidator.advertisement.rerBorders[0].type ?? null, 
                length: dataRow.AdValidator.advertisement.rerBorders[0]['length'] ?? null,
              }
            if(dataRow.AdValidator.advertisement.rerBorders[1])
              this.Borders[1] = {
                Direction: dataRow.AdValidator.advertisement.rerBorders[1].direction ?? null, 
                Type: dataRow.AdValidator.advertisement.rerBorders[1].type ?? null, 
                length: dataRow.AdValidator.advertisement.rerBorders[1]['length'] ?? null,
              }
            if(dataRow.AdValidator.advertisement.rerBorders[2])
              this.Borders[2] = {
                Direction: dataRow.AdValidator.advertisement.rerBorders[2].direction ?? null, 
                Type: dataRow.AdValidator.advertisement.rerBorders[2].type ?? null, 
                length: dataRow.AdValidator.advertisement.rerBorders[2]['length'] ?? null,
              }
            if(dataRow.AdValidator.advertisement.rerBorders[3])
              this.Borders[3] = {
                Direction: dataRow.AdValidator.advertisement.rerBorders[3].direction ?? null, 
                Type: dataRow.AdValidator.advertisement.rerBorders[3].type ?? null, 
                length: dataRow.AdValidator.advertisement.rerBorders[3]['length'] ?? null,
              }
          }
          this.LandTotalPrice = dataRow.AdValidator.advertisement.landTotalPrice ?? null;
          this.TotalAnnualRentForTheLand = dataRow.AdValidator.advertisement.landTotalAnnualRent ?? null;
          this.Notes = dataRow.AdValidator.advertisement.notes ?? null;
          this.LocationDescriptionAccordingToDeed = dataRow.AdValidator.advertisement.locationDescriptionOnMOJDeed ?? null;
          this.ownershipTransferFeeType = dataRow.AdValidator.advertisement.ownershipTransferFeeType ?? null;
          this.responsibleEmployeeName = dataRow.AdValidator.advertisement.responsibleEmployeeName ?? null;
          this.responsibleEmployeePhoneNumber = dataRow.AdValidator.advertisement.responsibleEmployeePhoneNumber ?? null;
          this.IsConstrained = dataRow.AdValidator.advertisement.isConstrained ?? false;
          this.TitleDeedType = dataRow.AdValidator.advertisement.titleDeedTypeName.trim() ?? null;
          this.getCitiesList(false);
          this.getNeighborhoodsList(false);
        }
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    getCitiesList(change=true){
      this.hasError = false;
      this.hasSucess = false;
      this.citiesList = [];
      this.neighborhoodsList = [];
      if(change){
        this.NationalAddress.City = null;
        this.NationalAddress.District = null;
      }
      if(!this.NationalAddress.Region){
        return;
      }
      this.$http.get(`/api/admin/cities/list?regaId=${this.NationalAddress.Region}&all=1`).then(({data}) => {
        this.citiesList = data.cities;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    getNeighborhoodsList(change=true){
      this.hasError = false;
      this.hasSucess = false;
      this.neighborhoodsList = [];
      if(change)
        this.NationalAddress.District = null;
      if(!this.NationalAddress.City){
        return;
      }
      this.$http.get(`/api/admin/neighborhoods/list?regaId=${this.NationalAddress.City}&all=1`).then(({data}) => {
        this.neighborhoodsList = data.neighborhoods;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;
      
      if(
        !this.OperationType || !this.OperationReason || !this.AdLinkInPlatform || 
        !this.AdLicenseNumber || !this.TitleDeedNumber || !this.CreationDate ||
        !this.EndDate || !this.AdvertiserID || !this.AdvertiserName || 
        !this.AdvertiserMobile || !this.Channels || !this.NationalAddress || 
        !this.PropertyType || !this.PropertyArea || !this.Price || 
        !this.PropertyUtilities.length || !this.AdType || 
        !this.adLicenseURL || !this.AdSource
      ){
        this.message = 'يجب إدخال البيانات الإلزامية';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
        return false;
      }

      let bordersVal = [];
      if(
        this.Borders[0].Direction || this.Borders[0].Type || this.Borders[0]['length'] || 
        this.Borders[1].Direction || this.Borders[1].Type || this.Borders[1]['length'] || 
        this.Borders[2].Direction || this.Borders[2].Type || this.Borders[2]['length'] || 
        this.Borders[3].Direction || this.Borders[3].Type || this.Borders[3]['length']
      )
        bordersVal = this.Borders;

      const payload = {
        operationType: this.OperationType,
        operationReason: this.OperationReason,
        adLinkInPlatform: this.AdLinkInPlatform,
        adLicenseNumber: this.AdLicenseNumber,
        titleDeedNumber: this.TitleDeedNumber,
        creationDate: this.CreationDate,
        endDate: this.EndDate,
        advertiserId: this.AdvertiserID,
        advertiserName: this.AdvertiserName,
        advertiserMobile: this.AdvertiserMobile,
        channels: this.Channels,
        nationalAddress: this.NationalAddress,
        propertyType: this.PropertyType,
        propertyArea: this.PropertyArea,
        price: this.Price,
        propertyUtilities: this.PropertyUtilities,
        adType: this.AdType,
        isConstrained: this.IsConstrained,
        adLicenseUrl: this.adLicenseURL,
        adSource: this.AdSource,
        brokerageAndMarketingLicenseNumber: this.BrokerageAndMarketingLicenseNumber,
        propertyFace: this.PropertyFace, 
        propertyUsage: this.PropertyUsage, 
        streetWidth: this.StreetWidth, 
        propertyAge: this.PropertyAge, 
        roomsNumber: this.RoomsNumber, 
        obligationsOnTheProperty: this.ObligationsOntheProperty, 
        guaranteesAndTheirDuration: this.GuaranteesAndTheirDuration, 
        planNumber: this.PlanNumber, 
        landNumber: this.landNumber, 
        complianceWithTheSaudiBuildingCode: this.ComplianceWithTheSaudiBuildingCode, 
        titleDeedType: this.TitleDeedType, 
        northLimitName: this.NorthLimitName, 
        northLimitDescription: this.NorthLimitDescription, 
        northLimitLengthChar: this.NorthLimitLengthChar, 
        eastLimitName: this.EastLimitName, 
        eastLimitDescription: this.EastLimitDescription, 
        eastLimitLengthChar: this.EastLimitLengthChar, 
        westLimitName: this.WestLimitName, 
        westLimitDescription: this.WestLimitDescription, 
        westLimitLengthChar: this.WestLimitLengthChar, 
        southLimitName: this.SouthLimitName, 
        southLimitDescription: this.SouthLimitDescription, 
        southLimitLengthChar: this.SouthLimitLengthChar, 
        borders: bordersVal, 
        landTotalPrice: this.LandTotalPrice, 
        totalAnnualRentForTheLand: this.TotalAnnualRentForTheLand, 
        notes: this.Notes, 
        locationDescriptionAccordingToDeed: this.LocationDescriptionAccordingToDeed, 
        ownershipTransferFeeType: this.ownershipTransferFeeType, 
        responsibleEmployeeName: this.responsibleEmployeeName, 
        responsibleEmployeePhoneNumber: this.responsibleEmployeePhoneNumber, 
      }
      
      this.$http.post(`/api/admin/properties/regaUpdate/${this.id}`, payload).then(({data}) => {
        this.message = 'تم الإرسال بنجاح';
        this.hasSucess = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
    formatDate(date){
      const [day, month, year] = date.split('/');
      return `${year}-${month}-${day}`;
    }
  },
  created(){
    this.getInitData();
  }
}
</script>
